/* eslint-disable linebreak-style */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { ISettingsTable } from '../../interfaces/table.interface';

import { IEventAction } from '../components/ami-table-actions/ami-table-actions.interface';

@Component({
  template: ''
})
export class TableActionsBaseTemplate {
  @Output() itemSelected = new EventEmitter<IEventAction>();
  @Output() reciveActionHead = new EventEmitter<IEventAction>();
  table: {
    settings: ISettingsTable;
    data: any[];
    actions: any;
    actionsHead: any;
  } = {
    settings: {
      title: '',
      columns: []
    },
    data: null,
    actions: null,
    actionsHead: null
  };
  open = false;
  message: IDialogMessage;
  suscriptionBase$: Subscription;

  onClose() {
    this.open = false;
  }

  onReciveAction(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      this.open = true;
      this.itemSelected.emit({ action, data });
    }
  }
  onReciveActionHead(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      this.open = true;
      this.reciveActionHead.emit({ action, data });
    }
  }
  unsubscribeBase() {
    this.suscriptionBase$?.unsubscribe();
  }
}
